import React from "react";
import { Modal } from "react-bootstrap";
import ModalHeader from "./../../../EmployeeProfileModal/ModalHeader";
import "./../../OverideModal.css";
import { FormSection, FormFieldGroup } from "component-library/formSections";

const EligibilityPeriodModal = ({ show, onCancel, onSave }) => {
  return (
    <Modal
      id="override-termination-modal"
      bsClass="override-termination-modal entity-page-cancel-modal modal"
      animation={false}
      backdrop={"static"}
      keyboard={false}
      show={show}
      onHide={onCancel}
      restoreFocus={false}
    >
      <ModalHeader onClose={onCancel} />
      <Modal.Body>
        <div id="override-termination-modal-body" className="modal-row">
          <div className="modal-header">
            Edit Your Company's Eligibility Determination Period
          </div>

          <div style={{ marginBottom: "20px" }}>
            Before changing your company's Eligibility Determination Period,
            note that the Deprtment of Labor states that employers should
            uniformly apply the same option to all employees taking FMLA leave.
          </div>
          <FormSection>
            <FormFieldGroup
              inputName="calendarYear"
              label=""
              inputType="dropDown"
            />
          </FormSection>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div
          id="cancel-modal-footer"
          className="button-group"
          style={{ textAlign: "left" }}
        >
          <button
            type="button"
            id="save-modal-button"
            className="nc-button primary-button"
            onClick={onSave}
          >
            Save Changes
          </button>

          <button
            type="button"
            id="save-modal-button"
            className="nc-button secondary-link-button"
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default EligibilityPeriodModal;
